import { render } from "./GlobalToast.vue?vue&type=template&id=2a9a61bc"
import script from "./GlobalToast.vue?vue&type=script&lang=js"
export * from "./GlobalToast.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__